import React from 'react'

const NotificationEmail = () => {
  return (
    <div>NotificationEmail</div>
  )
}

export default NotificationEmail